import axios from 'axios'
import Token from './Token'

const replace = '%QUERY%'
let query     = `mutation { ${replace} }`
let isUpload  = false
let formData  = null

class Mutation
{
    static addPO(params)
    {
        let q = isUpload ?
            `add_new_po(documents: ${params.documents}, note: \\"${params.note}\\", bin: \\"${params.bin}\\", code: \\"${params.code}\\", solo: \\"${params.solo}\\", vehicle_owner: \\"${params.vehicle_owner}\\", price: ${params.price}, material_id: ${params.material_id}, amount: ${params.amount}, supplier_id: ${params.supplier_id}, vehicle_no: \\"${params.vehicle_no}\\", inputsourcetype_id: ${params.inputsourcetype_id}, field_id: ${params.field_id}, container_id: \\"${params.container_id}\\") { id amount }`:
            `add_new_po(documents: ${params.documents}, note: "${params.note}", bin: "${params.bin}", code: "${params.code}", solo: "${params.solo}", vehicle_owner: "${params.vehicle_owner}", price: ${params.price}, material_id: ${params.material_id}, amount: ${params.amount}, supplier_id: ${params.supplier_id}, vehicle_no: "${params.vehicle_no}", inputsourcetype_id: ${params.inputsourcetype_id}, field_id: ${params.field_id}, container_id: "${params.container_id}") { id amount }`;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static addTO(params)
    {
        let q = isUpload ?
            `add_new_to(documents: ${params.documents}, note: \\"${params.note}\\", bin: \\"${params.bin}\\", device_id: ${params.device_id}, solo: \\"${params.solo}\\", description: \\"${params.description}\\" action_id: ${params.action_id},shift_id: ${params.shift_id}, from_amount: ${params.from_amount}, from_material: ${params.from_material}, from_container: ${params.from_container}, to_amount: ${params.to_amount}, to_material: ${params.to_material}, to_container: \\"${params.to_container}\\") { id }`:
            `add_new_to(documents: ${params.documents}, note: "${params.note}", bin: "${params.bin}", device_id: ${params.device_id}, solo: "${params.solo}", description: "${params.description}" action_id: ${params.action_id},shift_id: ${params.shift_id}, from_amount: ${params.from_amount}, from_material: ${params.from_material}, from_container: ${params.from_container}, to_amount: ${params.to_amount}, to_material: ${params.to_material}, to_container: "${params.to_container}") { id }`;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static addMO(params)
    {
        let q = isUpload ?
            `add_new_mo(documents: ${params.documents}, cover_detail: \\"${params.cover_detail}\\" bin: \\"${params.bin}\\", actual_figures: ${params.actual_figures}, solo: \\"${params.solo}\\", cover_amount: ${params.cover_amount}, cardboard_size: ${params.cardboard_size}, amount: ${params.amount}, material_id: ${params.material_id}, packing: ${params.packing}, from_containers: \\"${params.from_containers}\\", to_containers: \\"${params.to_containers}\\") { id }`:
            `add_new_mo(documents: ${params.documents}, cover_detail: "${params.cover_detail}" bin: "${params.bin}", actual_figures: ${params.actual_figures}, solo: "${params.solo}", cover_amount: ${params.cover_amount}, cardboard_size: ${params.cardboard_size}, amount: ${params.amount}, material_id: ${params.material_id}, packing: ${params.packing}, from_containers: "${params.from_containers}", to_containers: "${params.to_containers}") { id }`;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static transferCovers(params)
    {
        let q = `transfer_covers(inventory_id: ${params.inventory_id}, supplier_id: ${params.supplier_id}, cover_id: ${params.cover_id}, amount: ${params.amount}, price: ${params.price}, solo: "${params.solo}") { id }`;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static addSO(params)
    {
        let q = isUpload ?
            `add_new_so(documents: ${params.documents}, vat: ${params.vat || 0}, for_internal: ${params.for_internal} company_name: "\${params.company_name}\" notes: \"${params.notes}\", samecont: \"${params.samecont}\" is_exception: ${params.is_exception}, customer_id: ${params.customer_id}, shipping_unit: \"${params.shipping_unit}\" vehicle: \"${params.vehicle}\", estimated_at: \"${params.estimated_at}\") { id }`:
            `add_new_so(documents: ${params.documents}, vat: ${params.vat || 0}, for_internal: ${params.for_internal} company_name: "${params.company_name}" notes: "${params.notes}", samecont: "${params.samecont}" is_exception: ${params.is_exception}, customer_id: ${params.customer_id}, shipping_unit: "${params.shipping_unit}" vehicle: "${params.vehicle}", estimated_at: "${params.estimated_at}") { id }`;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static addSODetail(params)
    {
        let q = isUpload ?
            `add_new_sodetail(vat: ${params.vat || 0}, company_name: \"${params.company_name}\", notes: \"${params.notes}\", samecont: ${params.samecont || 0}, shipping_unit: \"${params.shipping_unit}\", estimated_at: \"${params.estimated_at}\", vehicle: \"${params.vehicle}\",so_id: ${params.so_id}, data: \"${params.data}\") { id }`:
            `add_new_sodetail(vat: ${params.vat || 0}, company_name: "${params.company_name}", notes: "${params.notes}", samecont: ${params.samecont || 0}, shipping_unit: "${params.shipping_unit}", estimated_at: "${params.estimated_at}", vehicle: "${params.vehicle}",so_id: ${params.so_id}, data: "${params.data}") { id }`;
        query = query.replace(replace, `${q} ${replace}`)


        return this
    }

    static addSupplier(params)
    {
        let q = isUpload ?
            `add_new_supplier(name: \\"${params.name}\\", address: \\"${params.address}\\") { id }` :
            `add_new_supplier(name: "${params.name}", address: "${params.address}") { id }`;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static reorderSos(data)
    {
        let q = isUpload ?
            `reorder_sos(data: \\"${data}\\")` :
            `reorder_sos(data: "${data}")`;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static editFormulaDetail(params)
    {
        let q = isUpload ?
            `edit_formula_detail(formula_id: ${params.formula_id}, formulaDetails: \\"${params.formulaDetails}\\" ) { id material_id percent material { id name } }` :
            `edit_formula_detail(formula_id: ${params.formula_id}, formulaDetails: "${params.formulaDetails}" ) { id material_id percent material { id name } }`;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static editShiftUser(params)
    {
        let q = isUpload ?
            `edit_shift_user(data: \\"${params}\\") { id shift employees { id name is_checked } }` :
            `edit_shift_user(data: "${params}") { id shift employees { id name is_checked } }` ;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static addSuppliment(params)
    {

        let q = isUpload ?
            `new_suppliment(id: ${params.id}, data: \\"${params.data}\\") { id }`:
            `new_suppliment(id: ${params.id}, data: "${params.data}") { id }`;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static addCommonSuppliment(data)
    {

        let q = isUpload ?
            `add_common_suppliment(data: \\"${data}\\") { id }`:
            `add_common_suppliment(data: "${data}") { id }`;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static updateSupplimentStatus(params)
    {
        let q = `update_suppliment_status(id: ${params.id}, is_completed: ${params.is_completed}) { id is_created_suppliment }`;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static addCustomer(name)
    {
        let q = isUpload ?
            `add_new_customer(name: \\"${name}\\") { id }`:
            `add_new_customer(name: "${name}") { id }`;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static changeView(id)
    {
        let q = isUpload ?
            `change_view(id: \\"${id}\\") { employee_id customer_id }`:
            `change_view(id: "${id}") { employee_id customer_id }`;
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static changeCapacity(id, capacity)
    {
        let q = `change_capacity(id: ${id}, capacity: ${capacity}) { id name containers(material_id: null, strict: null) { id name updated_at capacity max_capacity containertype_id suppliers material { id name materialtype { color } } } }`
        query = query.replace(replace, `${q} ${replace}`)

        return this
    }

    static addFiles(files) {
        if (! files) return this

        formData = formData ? formData : new FormData()
        let map  = formData.has('map') ? JSON.parse(formData.get('map')) : {}

        Array.from(files).forEach((file, index) => {
            formData.append(index, file, file.name)
            map[index] = ['variables.files.' + index]
        })

        formData.set('map', JSON.stringify(map))
        isUpload = true

        if (! query.includes('mutation($files: [Upload!]!)'))
            query = query.replace('mutation', 'mutation($files: [Upload!]!)')

        return this
    }

    static async upload() {
        let q = query.replace(replace, '')
        query = `mutation { ${replace} }`

        let userLogin = JSON.parse(localStorage.userLogin)
        let options   = {
            'headers': {
                'token': userLogin.token,
                'Content-Type': 'multipart/form-data',
            },
        }

        formData = formData ? formData : new FormData()
        formData.append('operations', `{"query": "${q}"}`)
        let keepForm = formData
            formData = null

        return await axios.post('/cmrice', keepForm, options)
    }

    static async submit() {
        let q = query.replace(replace, '')
        query = `mutation { ${replace} }`

        return await axios.post('/cmrice', {query: q}, Token())
    }

    static async execute() {
        let result = isUpload ? await this.upload() : await this.submit()
        isUpload   = false

        return result
    }
}

export default Mutation